// NOTE: IMPORT OTHER CONSTANTS AND DEPENDENCIES
import Root from "../Layout/Root";
import { createBrowserRouter } from "react-router-dom";

// NOTE: IMPORT AUTH PAGES
// import SignIn from "../pages/Login/SignIn";
import SignIn from "../pages/Login/SignInLandLoad";
import ForgotPassword from "../pages/Login/ForgotPasswordLandLoad";
import SetNewPassword from "../pages/Login/SetNewPasswordLandLoad";

// NOTE: IMPORT COMMON PAGES
import ErrorPage from "../error/Error";
import ServerError from "../error/ServerError";

// NOTE: IMPORT TEST PAGES
import { UseConfirmationTesting } from "../pages/TestConfirmation";

// NOTE: IMPORT HOOKS
import {
  ProtectedClientRoute,
  ProtectedLandLodRoute,
  PublicRoute,
} from "../components/protectedAndPublicRoute";
import LandLodClientHome from "../pages/LandLord/LandLodClientHome";
import LandLordTestArea from "../pages/LandLord/LandLordTestArea";
import LandlodLayout from "../Layout/LandlodLayout";

// IMPORT LANDLORD NAVIGATION PAGES
import OccupancyRatePage from "../pages/LandLord/OccupancyRate";
import PaymentDistributionPage from "../pages/LandLord/PaymentDistribution";
import PaymentHistoryPage from "../pages/LandLord/PaymentHistory";
import PortfolioPerformanceReportPage from "../pages/LandLord/PortfolioPerformanceReport";
import LegalSupportPage from "../pages/LandLord/LegalSupport";
import TaxConsulationPage from "../pages/LandLord/TaxConsulation";
import ReqMaintaincePage from "../pages/LandLord/ReqMaintaince";

import TenantRentPayment from "../pages/Tenant/TenantRentPayment";
import ViewPaymentsPage from "../pages/LandLord/ViewPaymentsPage";
//import ManageLands from "../pages/LandLord/ManageLands";
import ManageLands from "../pages/Admin/ManageLands";
import SupportLogs from "../pages/LandLord/SupportLogs";
import PaymentMonitoring from "../pages/LandLord/PaymentMonitoring";
//import Tenantdetailsform from "../pages/LandLord/Tenantdetailsform";
import LoginLayout from "../Layout/LoginLayout";
import PayMonitoring from "../pages/Admin/PayMonitoring";
import SamplePage from "../pages/LandLord/SamplePage";
import SupportEmailSettings from "../pages/Admin/SupportEmailSettings";
import ManageLandlordsPage from "../pages/Admin/ManageLandlordsPage";
import AdminPayoutPage from "../pages/Admin/AdminPayoutPage";
import TenantPaymentActivity from "../pages/Admin/TenantPaymentActivity";
import PaymentHistory from "../pages/Admin/PaymentHistory";
import Overview from "../pages/LandLord/Overview";
import LandlordProfile from "../pages/LandLord/LandlordProfile";
import LandLordTestSummary from "../pages/LandLord/LandLordTestSummary";
import TenantDetailPage from "../pages/LandLord/TenantDetailPage";
import Insights from "../pages/LandLord/Insights";

const router = createBrowserRouter([

  // Auth Routes with LoginLayout
  {
    path: "/",
    element: <LoginLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <SignIn />,
      },
      {
        path: "",
        element: <PublicRoute />,
        children: [
          {
            path: "signin",
            element: <SignIn />,
          },
          {
            path: "forgot-password",
            element: <ForgotPassword />,
          },
          {
            path: "reset-password",
            element: <SetNewPassword />,
          },
        ]
      },      
    ]
  },

  // dashboard layout - authenticated
  {
    path: "/landlords",
    element: <ProtectedLandLodRoute />,
    children: [
      {
        element: <LandlodLayout />,
        children: [
          {
            path: "overview",
            element: <Overview/>

          },
          {
            path: "insights",
            element: <Insights/>

          },
           {
             path: "portfolio-performance-report",
             element: <PortfolioPerformanceReportPage/>
           },
           {
             path: "payment-distribution",
             element: <PaymentDistributionPage/>
           },
          {
            path: "support-email-settings",
            element: <SupportEmailSettings/>
          },
          {
            path: "paymonitoring",
            element: <PayMonitoring />
          }, 
          {
            path: "support-logs",
            element: <SupportLogs />
          },
          {
            path: "tenant-payment-activity",
            element: <TenantPaymentActivity />
          },
          {
            path: "admin-manage-landload",
            element: <ManageLandlordsPage />
          },
        /*  {
            path: "admin-manage-landload/:userId/:propertyId",
            element: <ManageProperty />
          },*/
          {
            path: "admin-manage-landload/view-properties/:userId",
            element: <ManageLands />
          },
          {
            path: "admin-manage-landload/manage-property/view-details/:propertyId",
            element: <LandLordTestSummary />,
          },
          {
            path: "manage-property/payments/:unitId",
            element: <ViewPaymentsPage />,
          },
          {
            path: "manage-property/:propertyId/:unitId/add-tenant",
            element: <TenantDetailPage />
          },
          {
            path: "manage-property/:propertyId/:unitId/edit-tenant",
            element: <TenantDetailPage />
          },
          {
            path: "admin-payout",
            element: <AdminPayoutPage />
          },
          {
            path: "admin-payment-history",
            element: <PaymentHistory />
          },   
          {
            path: "occupancy-rate",
            element: <OccupancyRatePage />
          },
          {
            path: "admin-manage-landload/profile/:userId",
            element: <LandlordProfile />
          }       
        ]
      }
    ]
  },

  // Test Routes
  {
    path: "/test-confirmation",
    element: <UseConfirmationTesting />,
    errorElement: <ErrorPage />
  },
  {
    path: "landLordTestArea",
    element: <LandLordTestArea />,
  },
  {
    path: "SamplePage",
    element: <SamplePage />,
  },

  // Error Routes
  {
    path: "/server-error",
    element: <ServerError />,
    errorElement: <ErrorPage />
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
]);

export default router;